<template>
  <div class="graph">
    <curriculum
      v-if="curriculum"
      :curriculum="curriculum"
      v-bind="options"
      ref="curriculum"
    ></curriculum>
  </div>
</template>

<script>
import { Curriculum, buildCurriculum, BaseItem, BaseTerm } from '@damoursystems/curricular-visualization'

const CustomTerm = BaseTerm.extend({
  computed: {
    footer () {
      if (this.complexity) {
        return `Complexity: ${this.complexity.toFixed(1)}`
      } else {
        return `Credits: ${this.credits}`
      }
    }
  }
})
const CustomItem = BaseItem.extend({
  computed: {
    content () {
      if (this.original) {
        if (!(this.original.metrics === undefined)) { // Check that the metrics dictionary is defined
          let output = ''
          for (var metric in this.original.metrics) {
            output += `${metric}: ${this.original.metrics[metric]}<br />`
          }
          return output
        } else { // If it isn't defined use the plugins default content
          return `
            ${this.complexity} Complexity<br />
            ${this.blocking} Blocking Factor<br />
            ${this.delaying} Delay Factor<br />
          `
        }
      } else {
        return 0
      }
    },
    complexity () {
      if (this.original) {
        if (this.original.metrics) { // Check that metrics is defined
          if (this.original.metrics.complexity) { // Check that complexity is included in metrics
            return this.original.metrics.complexity
          }
        } else {
          return this.blocking + this.delaying
        }
      } else {
        return 0
      }
    },
    value () {
      if (this.complexity) {
        return this.complexity
      } else {
        return this.credits
      }
    }
  }
})

export default {
  data () {
    return {
      curriculum: null,
      options: {},
      format: null,
      exportFormat: null,
      height: 0
    }
  },

  components: {
    Curriculum
  },

  watch: {
    export: {
      handler (e) {
        if (!e) return
        window.parent.postMessage({ curriculum: e }, '*')
        setTimeout(() => {
          this.height = this.$el.getBoundingClientRect().height
        }, 0)
      },
      deep: true
    },

    height (height) {
      window.parent.postMessage({ height }, '*')
    }
  },

  methods: {
    receiveMessage (event) {
      const data = event.data
      if (data) {
        // Recieve Event Props
        ['options', 'format', 'exportFormat'].forEach(prop => {
          if (data[prop]) this[prop] = data[prop]
        })

        // Build Curriculum if Provided
        let curriculum = data.curriculum
        if (curriculum) this.curriculum = buildCurriculum(curriculum, { format: this.format, Item: CustomItem, Term: CustomTerm })
      }
    }
  },

  computed: {
    exports () {
      return this.curriculum ? this.curriculum.exports : {}
    },

    export () {
      return this.exportFormat ? this.exports[this.exportFormat]
        : this.curriculum ? this.curriculum.exportOriginal
          : {}
    }
  },

  created () {
    window.addEventListener('message', this.receiveMessage, false)
  },

  beforeDestroy () {
    window.removeEventListener('message', this.receiveMessage)
  }
}
</script>
